export default __webpack_public_path__ + "static/media/handle-icon.75eb6395.svg";